define('Eureka.MaxaPartPicker.MaxaPartPicker.SS2Model',
    [
        'SCModel',
        'Utils'
    ],
    function
        (
            SCModelModule,
            Utils
        ) {
        'use strict';

        var SCModel = SCModelModule.SCModel;

        function MaxaPartsPickerItemLoadModel (model, options) {
            SCModel.call(this, model, options);

            this.urlRoot = function urlRoot () {
                return Utils.getAbsoluteUrl(
                    getExtensionAssetsPath(
                        "Modules/MaxaPartPicker/SuiteScript2/MaxaPartPicker.Service.ss"
                    ), true
                )
            }
        }

        MaxaPartsPickerItemLoadModel.prototype = Object.create(SCModel.prototype);
        MaxaPartsPickerItemLoadModel.prototype.constructor = MaxaPartsPickerItemLoadModel;

        return MaxaPartsPickerItemLoadModel
    })
